import { render, staticRenderFns } from "./ReviewDetails.vue?vue&type=template&id=cace5fec&scoped=true&"
import script from "./ReviewDetails.vue?vue&type=script&lang=js&"
export * from "./ReviewDetails.vue?vue&type=script&lang=js&"
import style0 from "./ReviewDetails.vue?vue&type=style&index=0&id=cace5fec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cace5fec",
  null
  
)

export default component.exports